/* Colorbox
========================================================= */
export function initColorbox($) {
  const $targets = $('a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"]');
  if (!$targets.length) return;

  $targets.colorbox({
    photo: true,
    scalePhotos: true,
    maxWidth: '90%',
    maxHeight: '90%',
    opacity: 0.7,
    fixed: true,
  });
}
